import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=7e4748af&"
import script from "./QuickLinks.vue?vue&type=script&lang=js&"
export * from "./QuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&id=7e4748af&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4748af')) {
      api.createRecord('7e4748af', component.options)
    } else {
      api.reload('7e4748af', component.options)
    }
    module.hot.accept("./QuickLinks.vue?vue&type=template&id=7e4748af&", function () {
      api.rerender('7e4748af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Hotel/QuickLinks.vue"
export default component.exports